import React, { useState } from "react";
import "./DonateNow.css";

/* ================= SVG ICONS ================= */
const BankIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 21h18" />
    <path d="M3 10h18" />
    <path d="M5 6l7-3 7 3" />
    <path d="M4 10v11" />
    <path d="M20 10v11" />
    <path d="M8 14v3" />
    <path d="M12 14v3" />
    <path d="M16 14v3" />
  </svg>
);

const QrIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="5" height="5" x="3" y="3" rx="1" />
    <rect width="5" height="5" x="16" y="3" rx="1" />
    <rect width="5" height="5" x="3" y="16" rx="1" />
    <path d="M21 16h-3v3h3v-3z" />
    <path d="M16 21h-3v-3h3v3z" />
    <path d="M12 3v18" />
    <path d="M3 12h18" />
  </svg>
);

const SendIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="m22 2-7 20-4-9 9-4Z" />
    <path d="M22 2 11 13" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366" stroke="#25D366" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

/* ================= COMPONENT ================= */
function DonateNow() {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    amount: "",
    location: "",
    occasion: ""
  });

  const [successMsg, setSuccessMsg] = useState(false);

  const occasionsList = [
    "Select an Occasion",
    "General Donation / Charity",
    "Marriage Anniversary",
    "Birthday Celebration",
    "In Loving Memory of Parents",
    "Festival Offering (Diwali, Pongal, etc.)",
    "New Job / Career Growth",
    "Child's Education Blessing",
    "Housewarming Thanksgiving",
    "Recovery from Illness",
    "Corporate Social Responsibility (CSR)"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.name || !formData.mobile || !formData.amount || !formData.occasion) {
      alert("Please fill in all mandatory fields.");
      return;
    }

    // 1. Create unique ID and timestamps
    const newRecord = {
      id: "DON-" + Date.now(),
      name: formData.name,
      mobile: formData.mobile,
      amount: formData.amount,
      location: formData.location || "Not Specified",
      occasion: formData.occasion,
      date: new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
    };

    // 2. Persist to shared LocalStorage for DonorsList retrieval
    const existingList = JSON.parse(localStorage.getItem("ANUK_DONORS_LIST")) || [];
    const updatedList = [newRecord, ...existingList];
    localStorage.setItem("ANUK_DONORS_LIST", JSON.stringify(updatedList));

    // 3. Build detailed payload for WhatsApp notification to Trust Administration
    // UPDATED NUMBER: 918668106574
    const trustWhatsAppNumber = "918668106574"; 
    const messageText = `Hello Trust Admin, I have successfully made a donation.\n\n*Donor Details:*\n• Name: ${formData.name}\n• Mobile: ${formData.mobile}\n• Amount: ₹${formData.amount}\n• Location: ${formData.location || "N/A"}\n• Occasion: ${formData.occasion}\n\n_Note: Attached payment screenshot._`;

    const encodedMessage = encodeURIComponent(messageText);
    const whatsappUrl = `https://wa.me/${trustWhatsAppNumber}?text=${encodedMessage}`;

    setSuccessMsg(true);

    // Open notification window to trigger WhatsApp immediately
    setTimeout(() => {
      window.open(whatsappUrl, "_blank");
      // Reset form variables
      setFormData({ name: "", mobile: "", amount: "", location: "", occasion: "" });
      setTimeout(() => setSuccessMsg(false), 5000);
    }, 1000);
  };

  return (
    <div className="donate-page-wrapper">
      
      {/* ================= HERO BANNER ================= */}
     <section
  className="donate-hero"
  style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-overlay"></div>

  <div className="hero-content">
    <h1
  className="hero-title"
  style={{
    textAlign: "center"
  }}
>
  Donate Now
</h1>

    <div className="hero-breadcrumb">
      <span className="breadcrumb-link">Home</span>
      <span className="breadcrumb-arrow">➔</span>
      <span className="breadcrumb-current">Donate Now</span>
    </div>
  </div>
</section>

      {/* ================= DUAL COLUMN MAIN LAYOUT ================= */}
      <section className="donate-main-section">
        <div className="donate-container">
          
          <div className="donate-grid">
            
            {/* LEFT COLUMN: BANKING INSTRUCTIONS & QR CODE */}
            <div className="banking-side">
              
              <div className="banking-header">
                <span className="badge-banking">SECURE CHANNELS</span>
                <h2 className="banking-title">Direct Transfer Details</h2>
                <p className="banking-desc">
                  Your transparent generosity empowers immediate, on-the-ground relief. Contributions are officially documented instantly.
                </p>
              </div>

              {/* Account Details Box */}
              <div className="bank-card">
                <div className="card-top-bar">
                  <BankIcon />
                  <span>Official Trust Account</span>
                </div>
                <div className="bank-info-rows">
                  <div className="info-row">
                    <span className="info-label">Bank Name</span>
                    <span className="info-val bold">Bank of Baroda</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Account Holder</span>
                    <span className="info-val">Anuk Charitable Trust</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Account Number</span>
                    <span className="info-val highlight">76720200002280</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">IFSC Code</span>
                    <span className="info-val bold">BARB0VJPOND</span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Branch</span>
                    <span className="info-val">Pondicherry Branch</span>
                  </div>
                </div>
              </div>

              {/* QR Code Container */}
             <div className="qr-card">

  {/* ORIGINAL QR IMAGE */}
  <div className="qr-visual-box">

    <img
      src="images/qr-code.png"   // replace with your original QR image path
      alt="PAYTM UPI QR"
      className="paytm-qr-image"
    />

  </div>

  {/* QR DETAILS */}
  <div className="qr-instructions">

    <h4>Scan & Pay via any UPI App</h4>

    <p>
      Google Pay, PhonePe, Paytm, BHIM
    </p>

    <span className="upi-id">
      UPI ID: 8838292123@ptaxis
    </span>

  </div>

</div>

              {/* Mandatory Post-Donation Instruction */}
              <div className="important-notification-box">
                <div className="notification-icon-wrapper">
                  <WhatsAppIcon />
                </div>
                <div className="notification-text">
                  <span className="note-title">CRITICAL NEXT STEP:</span>
                  <p>
                    Once you make a payment, kindly share the successful transaction screenshot on this WhatsApp number: <strong>+91 86681 06574</strong>.
                  </p>
                </div>
              </div>

            </div>

            {/* RIGHT COLUMN: DONOR SUBMISSION FORM */}
            <div className="form-side">
              
              <div className="form-card">
                
                <div className="form-card-head">
                  <h3>Donor Information Form</h3>
                  <p>Submit this record to update the registry instantly.</p>
                </div>

                {successMsg && (
                  <div className="success-banner">
                    <p>✓ Registry updated! Opening WhatsApp connection to notify the management...</p>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="donation-submission-form">
                  
                  {/* Full Name */}
                  <div className="input-group">
                    <label>Full Name <span className="req">*</span></label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter your complete name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Mobile Number */}
                  <div className="input-group">
                    <label>Mobile Number <span className="req">*</span></label>
                    <input
                      type="tel"
                      name="mobile"
                      placeholder="e.g., 9876543210"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      required
                    />
                    <span className="input-hint">Used for official verification confirmations.</span>
                  </div>

                  {/* Contribution Amount */}
                  <div className="input-group">
                    <label>Contribution Amount (₹) <span className="req">*</span></label>
                    <input
                      type="number"
                      name="amount"
                      placeholder="Enter value in INR"
                      value={formData.amount}
                      onChange={handleInputChange}
                      min="1"
                      required
                    />
                  </div>

                  {/* Location */}
                  <div className="input-group">
                    <label>City / Location</label>
                    <input
                      type="text"
                      name="location"
                      placeholder="Enter your present location"
                      value={formData.location}
                      onChange={handleInputChange}
                    />
                  </div>

                  {/* Occasion Dropdown */}
                  <div className="input-group">
                    <label>Occasion / Offering Reason <span className="req">*</span></label>
                    <select
                      name="occasion"
                      value={formData.occasion}
                      onChange={handleInputChange}
                      required
                    >
                      {occasionsList.map((item, idx) => (
                        <option key={idx} value={idx === 0 ? "" : item} disabled={idx === 0}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Form Trigger Button */}
                  <button type="submit" className="btn-submit-donation">
                    <span>Submit & Notify via WhatsApp</span>
                    <SendIcon />
                  </button>

                </form>

              </div>

            </div>

          </div>

        </div>
      </section>

    </div>
  );
}

export default DonateNow;